import * as z from "zod";
//#region src/__generated__/external/dictionaries/zod/downloadCargoFlowsTemplateSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const downloadCargoFlowsTemplateStatus200Schema = z.instanceof(File);
const downloadCargoFlowsTemplateResponseSchema = downloadCargoFlowsTemplateStatus200Schema;
//#endregion
//#region src/__generated__/external/dictionaries/zod/dictionaryItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dictionaryItemSchema = z.object({
	code: z.string().nullish().describe("Код значения").meta({ examples: ["MOSKOVSKAYA"] }),
	displayName: z.string().nullish().describe("Отображаемое наименование").meta({ examples: ["Московская железная дорога"] })
}).describe("Элемент справочника");
//#endregion
//#region src/__generated__/external/dictionaries/zod/dictionariesResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dictionariesResponseSchema = z.object({
	adjoiningTypes: z.array(dictionaryItemSchema).nullish(),
	applicantTypes: z.array(dictionaryItemSchema).nullish(),
	plannedWorksTypes: z.array(dictionaryItemSchema).nullish(),
	processingFlags: z.array(dictionaryItemSchema).nullish().describe("Признаки обработки — фильтр таблицы Оператора"),
	railways: z.array(dictionaryItemSchema).nullish(),
	requestSubjects: z.array(dictionaryItemSchema).nullish(),
	statuses: z.array(dictionaryItemSchema).nullish().describe("Статусы заявки — фильтр таблицы Заявителя"),
	trackFundings: z.array(dictionaryItemSchema).nullish()
}).describe("Справочники формы заявки и фильтров таблицы");
//#endregion
//#region src/__generated__/external/dictionaries/zod/getDictionariesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getDictionariesStatus200Schema = dictionariesResponseSchema.describe("Справочники формы заявки и фильтров таблицы");
const getDictionariesResponseSchema = getDictionariesStatus200Schema;
//#endregion
export { downloadCargoFlowsTemplateResponseSchema as a, dictionaryItemSchema as i, getDictionariesStatus200Schema as n, downloadCargoFlowsTemplateStatus200Schema as o, dictionariesResponseSchema as r, getDictionariesResponseSchema as t };

//# sourceMappingURL=getDictionariesSchema.js.map